"use client";
import { useState } from 'react';
import SolutionContent from './SolutionContent';
import styles from './styles.module.scss';
import Link from 'next/link';


const SolutionSelector = props => {
    const [currentSolution, setCurrentSolution] = useState(0);
    const {data} = props || {};

    const handleTabClick = e => {
        e.preventDefault();
        const id = e.target.dataset.id;

        if(id) {
            setCurrentSolution(id);
        }

    }
    const renderTabs = () => {
        return data && data.map((item, index)=> {
            return(
                <Link 
                    onClick={handleTabClick} 
                    data-id={index} 
                    key={index} 
                    href="#" 
                    className={`${styles.solutionSelector__tab} button small ${index == currentSolution ? `primary-fill` : 'white-fill'}`}
                >
                    {item?.title}
                </Link>
            );
        })
    }
    return (
        <div className={styles.solutionSelector}>
            <nav className={styles.solutionSelector__tabs}>
                {renderTabs()}
            </nav>
            <SolutionContent {...data[currentSolution]}/>
        </div>
    );
}
export default SolutionSelector;
